import BaseController from 'app/src/controllers/base/BaseController';

export default class PaymentProcessingController extends BaseController {
  constructor() {
    super();
  }

  /**
   * Provisioning for abstraction
   */
}
